// src/pages/friends-page/components/friends-card-info-modal/FriendsCardInfoModal.styles.js
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

export const ModalContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  height: 100%;
  width: 100%;
  max-width: 640px;
  max-height: 720px;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  margin: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const ModalBody = styled.div`
  padding: 0 24px 24px 24px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;


export const InfoLabel = styled.h4`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoValue = styled.p`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  word-break: break-word;
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  
  > div:first-child {
    flex-shrink: 0;
  }
`;

export const VariationsScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding-right: 8px;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
`;

export const VariationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const VariationItem = styled.div`
    box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
`;

export const UncollectedVariationItem = styled(VariationItem)`
  opacity: 0.5;
`;

export const VariationName = styled.p`
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  flex: 1;
  word-break: break-word;
`;

export const VariationRadio = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  cursor: pointer;

  input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #4CAF50;
    margin: 0;
  }

  label {
    display: flex;
    flex: 1;
    cursor: pointer;
    margin: 0;
  }
`;

export const EbayButton = styled.button`
  background: transparent;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 16px;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 80px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.8);
  }
`;

export const EbayDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
`;

export const EbayDescriptionHelpText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 12px 0;
  line-height: 1.5;
`;
